import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './OutdoorTextHighlight.css';

export interface OutdoorTextHighlightProps {
    text: string;
    search: RegExp;
    searchValue: string;
    cls?: string;
}

export const OutdoorTextHighlight = (props: OutdoorTextHighlightProps) => {
    const { text, search, searchValue } = props;

    if (searchValue) {
        const matchRegex = text.match(search) || [];

        return (
            <span
                className={`${Bem.cls('outdoor-text-highlight')} ${props.cls &&
                    props.cls}`}
            >
                {text
                    .split(search)
                    .reduce(
                        (
                            result: Array<string | JSX.Element>,
                            subString,
                            index
                        ) => {
                            return [
                                ...result,
                                subString,
                                <span
                                    className={Bem.cls({
                                        block: 'outdoor-text-highlight',
                                        elem: 'highlight'
                                    })}
                                    key={index.toString()}
                                >
                                    {matchRegex[index]}
                                </span>
                            ];
                        },
                        []
                    )}
            </span>
        );
    } else {
        return <>{text}</>;
    }
};
